import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  Badge,
  Box,
  CircularProgress,
  Grid,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTheme } from "@emotion/react";
import burgerImg from "../../assets/menuBurgerImg.png";
import MenuListCardsComponent from "./MenuListCardsComponent";
import DeleteIcon from "@mui/icons-material/Delete";
import TextInput from "../../components/Input/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { ArrowBackOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CreateWebShopOrder } from "../../api/Webshop.service";
import dayjs from "dayjs";
import {
  setSingleProductTotalIncludeSupp,
  updateOrderNumberDetails,
  updateTotalPrice,
} from "../../store/slice/Webshop.slice";
import { format_Number } from "../../utils/utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));


export default function Completebill({ open, handleClose, back }) {
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const checkoutCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "CardSectionWebshop"
  )?.fields
  const theme = useTheme();
  const dispatch = useDispatch();
  const currentDate = dayjs();
  const navigate = useNavigate();
  const {
    CurrencyData,
    webshopOpeningHours,
    shopType,
    webShopProductInfo,
    itemCount,
    addToCartProducts,
    supplementsInfo,
    webshopSettings,
    deliveryType,
    guestDetails,
    checkoutDetails,
    totalPrices,
    additionalFields,
    guestData,
    languageWords,
    singleProductTotalIncludeSupp
  } = useSelector((store) => store?.Webshop);
  const { key, resType } = useSelector((store) => store?.widgetSettings);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [loader, setLoader] = React.useState(false);
  const [totalVat, setTotalVat] = React.useState(0);
  const [totalPrice, setTotalPrice] = React.useState(0);

  const calculateTotalPrice = React.useCallback(
    (onlyVat = false) => {
      let vatAmount;
      const totalProductsPrice = addToCartProducts?.reduce((acc, product) => {
        const supplementInfo = supplementsInfo?.find(
          (item) => item?.idproduct === product.idproduct
        );
        const supplementTotal =
          supplementInfo?.supplements?.reduce(
            (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
            0
          ) || 0;
        const productTotal =
          (product.price * (itemCount[product.idproduct] || 0)) + (supplementTotal * (itemCount[product.idproduct] || 0))
        dispatch(setSingleProductTotalIncludeSupp({
          ...singleProductTotalIncludeSupp,
          [product.idproduct]: productTotal
      }));
        vatAmount =
          onlyVat || webshopSettings?.pricesIncludingVAT
            ? CalculateVat(productTotal, product?.vat || 0)
            : 0;
        return acc + productTotal + vatAmount;
      }, 0);

      if (onlyVat) {
        return vatAmount;
      }
      return totalProductsPrice;
    },
    [addToCartProducts, supplementsInfo, itemCount, webshopSettings]
  );


  function CalculateVat(price, vatPersentage) {
    const vat = (price / (vatPersentage + 100)) * vatPersentage;
    return Math.round(vat * 100) / 100;
  }

  const ProductPrice = (id, productPrice, vat) => {
    let vatAmount;
    const supplementInfo = supplementsInfo?.find(
      (item) => item?.idproduct == id
    );
    const supplementTotal =
      supplementInfo?.supplements?.reduce(
        (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
        0
      ) || 0;
    const productTotal = productPrice * (itemCount[id] || 0) + (supplementTotal * (itemCount[id] || 0));
    vatAmount = webshopSettings?.pricesIncludingVAT
      ? CalculateVat(productTotal, vat || 0)
      : 0;
    return productTotal + vatAmount;
  };

  const createOrderDetail = async () => {
   
    const extractSupplementIds = (supplements, detailsKey) => {
      return (
        supplements
          ?.filter((supItem) => supItem?.detailsKey === detailsKey)
          ?.map((supItem) => supItem?.idwebshopsupplementitem) || []
      );
    };

    const productItems = addToCartProducts?.map((item) => {
      const specialPrice = item?.specialPriceFields?.find((price) =>
        currentDate.isBetween(
          dayjs(price.specialpricefrom, "DD-MM-YYYY"),
          dayjs(price.specialpriceto, "DD-MM-YYYY"),
          null,
          "[]"
        )
      );

      const supplementsForProduct =
        supplementsInfo?.find(
          (supplement) => supplement?.idproduct === item?.idproduct
        )?.supplements || [];
      const supplementDetailsKeys = [
        "supplementProductsDetails1",
        "supplementProductsDetails2",
        "supplementProductsDetails3",
      ];
      const idSupplement1 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails1"
      );
      const idSupplement2 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails2"
      );
      const idSupplement3 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails3"
      );

      return {
        webshopOrderItemId: 0,
        productId: item.idproduct,
        quantity: itemCount[item.idproduct],
        PriceWithoutSupplement: item.price,
        price:  singleProductTotalIncludeSupp[item?.idproduct],
        isSpecialPrice: !!specialPrice,
        isRelatedProductPrice: item?.relatedproductprice ? true : false,
        idSupplement1: `[${idSupplement1.join(" ")}]`,
        idSupplement2: `[${idSupplement2.join(" ")}]`,
        idSupplement3: `[${idSupplement3.join(" ")}]`,
      };
    });

    const payload = {
      webshopOrder: {
        deliveryCost: webshopSettings?.deliveryStandardCost,
        selectedTime:checkoutDetails?.deliveryTime ||checkoutDetails?.showPickTime || checkoutDetails?.DineInTime,
        totalVAT: totalVat,
        totalCost: webshopSettings?.pricesIncludingVAT
          ? totalPrice - totalVat
          : totalPrice,
        totalIncludingVAT: webshopSettings?.pricesIncludingVAT
        ? totalPrice - totalVat
        : totalPrice,
        isPaid: true,
        isDelivery: deliveryType === "delivery",
        isDineIn: deliveryType === "DineIn",
        idguest: guestDetails?.value?.idguest || 0,
        paymentMethod: 2,
        isManualOrder: true,
        isKioskWidgetOrder: resType?.toLowerCase() == "kiosk",
        isWebshopOrder: resType?.toLowerCase() == "webshop",
      },
      webshopOrderItemsVM: productItems,
      key,
      guestData:guestData ,
      additionalGuestData:additionalFields, 
    };

    setLoader(true);
    try {
      const response = await CreateWebShopOrder(payload);
      if (response?.status == 200) {
        const { url, idOrder } = response.data;
        if (url && idOrder) {
        localStorage.setItem("orderId", idOrder);
        dispatch(updateOrderNumberDetails(response?.data));
        }
        navigate(
          `/webshopSuccess?status=success`
        );
      }
      setLoader(false);
      handleClose();
     
    } catch (error) {
      setLoader(false);
      console.error(error?.message);
    }
  };

  React.useEffect(() => {
    const total =calculateTotalPrice ();
    setTotalPrice(total);
    const vat = calculateTotalPrice(true);
    setTotalVat(vat);
  }, [calculateTotalPrice]);

  React.useEffect(() => {
    const overAllTotalPrice =
      totalPrice < webshopSettings?.freeDeliveryAfterAmount
        ? totalPrice + webshopSettings?.deliveryStandardCost
        : totalPrice;
    dispatch(updateTotalPrice(overAllTotalPrice));
  }, [totalPrice]);

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          sx: {
            width: isSmallScreen ? "100%" : "70%", 
            maxWidth: "none", 
            height: "auto",
            minHeight: "500px",
 
            
          },
        }}
      >
        <Box>
          <IconButton
            aria-label="close"
            onClick={back}
            sx={{
              position: "absolute",
              left: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <ArrowBackOutlined sx={{ color: "#F37120" }} />
          </IconButton>
          <DialogTitle
            id="recommendation-dialog-title"
            sx={{
              color: "#00000",
              fontWeight: "bold",
              fontSize: "1.2rem",
              mb: 3,
              textAlign: "center",
            }}
          >
            {languageWords?.Checkout}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ mt: 2 }}>
          <Box>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 5 }}>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                  }}
                >
                  {languageWords?.product}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 2 }}>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                  }}
                >
                 {languageWords?.price}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 3 }}>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                  }}
                >
                  {isSmallScreen ? languageWords?.Qty : languageWords?.quantity}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 2 }}>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                  }}
                >
                  {languageWords?.Total}
                </Typography>
              </Grid2>
            </Grid2>
            {addToCartProducts.map((item, index) => (
              <Grid2
                container
                key={index}
                sx={{ marginBottom: 2, mt: 2 }}
                spacing={2}
              >
                <Grid2 size={{ xs: 5 }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: isSmallScreen
                        ? "12px"
                        : isMediumScreen
                        ? "14px"
                        : "20px",
                    }}
                  >
                    {item.displayName}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 2 }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: isSmallScreen
                        ? "12px"
                        : isMediumScreen
                        ? "14px"
                        : "20px",
                    }}
                  >
                    
                    &euro;{format_Number(item.price)}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 3 }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: isSmallScreen
                        ? "12px"
                        : isMediumScreen
                        ? "14px"
                        : "20px",
                    }}
                  >
                    {itemCount[item?.idproduct]}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 2 }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: isSmallScreen
                        ? "12px"
                        : isMediumScreen
                        ? "14px"
                        : "20px",
                    }}
                  >
                    &euro;
                    {format_Number(
                      ProductPrice(item?.idproduct, item?.price, item?.vat)
                    )}
                  </Typography>
                </Grid2>
              </Grid2>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end", 
              marginTop: "1rem",
              mr: 2,
              mt: 5,
             
            }}
          >
            {totalPrice < webshopSettings?.freeDeliveryAfterAmount && (
              <Box
                sx={{
                  display: "flex",
                  gap: "3rem",
                  mb: 2,
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                    fontWeight: 500,
                  }}
                >
                 {languageWords?.deliverycost}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isSmallScreen
                      ? "12px"
                      : isMediumScreen
                      ? "14px"
                      : "20px",
                    fontWeight: 500,
                  }}
                >
                  {format_Number(webshopSettings?.deliveryStandardCost)}
                </Typography>
              </Box>
            )}
            <Box
              sx={{ display: "flex", gap: "3rem", mb: 2, alignItems: "center" }}
            >
              <Typography
                sx={{
                  fontSize: isSmallScreen
                    ? "12px"
                    : isMediumScreen
                    ? "14px"
                    : "20px",
                  fontWeight: 500,
                }}
              >
                {languageWords?.total}
              </Typography>
              <Typography
                sx={{
                  fontSize: isSmallScreen
                    ? "12px"
                    : isMediumScreen
                    ? "14px"
                    : "20px",
                  fontWeight: 500,
                }}
              >
                {CurrencyData?.value?.currencySymbol}
                {totalPrice < webshopSettings?.freeDeliveryAfterAmount
                  ? format_Number(
                      totalPrice + webshopSettings?.deliveryStandardCost
                    )
                  : format_Number(totalPrice)}
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", gap: "3rem", mb: 2, alignItems: "center" }}
            >
              <Typography
                sx={{
                  fontSize: isSmallScreen
                    ? "12px"
                    : isMediumScreen
                    ? "14px"
                    : "20px",
                  fontWeight: 500,
                }}
              >
               {languageWords?.VAT}
              </Typography>
              <Typography
                sx={{
                  fontSize: isSmallScreen
                    ? "12px"
                    : isMediumScreen
                    ? "14px"
                    : "20px",
                  fontWeight: 500,
                }}
              >
                {CurrencyData?.value?.currencySymbol}{format_Number(totalVat)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "3rem",
                alignItems: "center",
                borderTop: "1px solid black",
                pt: 2,
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                {languageWords?.TotalIncludingVAT}
              </Typography>
              <Typography sx={{ fontWeight: "bold" }}>
                {" "}
                {CurrencyData?.value?.currencySymbol}
                {totalPrice < webshopSettings?.freeDeliveryAfterAmount
                  ? format_Number(
                      totalPrice + webshopSettings?.deliveryStandardCost
                    )
                  : format_Number(totalPrice)}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
              sx={{
                backgroundColor: "#F37120",
                color: "#fff",
                width: "404px",
                p: 2,
              }}
          
              disabled={loader}
            >
              {loader ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {languageWords?.PayNow} &euro;{" "}
                  {totalPrice < webshopSettings?.freeDeliveryAfterAmount
                    ? format_Number(
                        totalPrice + webshopSettings?.deliveryStandardCost
                      )
                    : format_Number(totalPrice)}
                </>
              )}
            </Button>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>

    </React.Fragment>
  );
}
